import React, { PureComponent } from 'react';
import { IMAGES_REPO } from '../../config';

class HomeNews extends PureComponent {

  render() {
    const { body, image, link, title, numOfComments = 0 } = this.props;
    return (
      <div className="home-news">
        <div className="home-news-link">
          <div className="home-news-hover">
            <div className="home-news-hover-content">
              <a href={link} target="_blank">
                <button className="btn btn-xl">ver mais</button>
              </a>
            </div>
          </div>
          <img className="img-responsive" src={`${IMAGES_REPO}${image}`} alt={title}/>
        </div>
        <div className="home-news-caption">
          <div className="first">
            <h4>{title}</h4>
            {
              body && <div className="text-muted" dangerouslySetInnerHTML={{ __html: body }}/>
            }
          </div>
          <div className="last">
            <span className="comments">
              {numOfComments > 0 && <span>{numOfComments} <i className="fa fa-comments"></i></span>}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

HomeNews.propTypes = {};
HomeNews.defaultProps = {};

export default HomeNews;



// WEBPACK FOOTER //
// ./src/components/home-news/HomeNews.js